import { createFileRoute } from '@tanstack/react-router'
import { LaporanTable } from '../../../../components/LaporanTable'

export const Route = createFileRoute('/desa/$slug/dashboard/laporan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <LaporanTable desaId={desaId} />
  },
})
